import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { DeliveryTimeModel } from './deliveryTime.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class DeliveryTimeService {
  constructor(private http: HttpClient) {}

  addDeliveryTime(deliverytime: DeliveryTimeModel) {
    
    return this.http
      .post(API_URL + '/DeliveryTime/CreateDeliveryTime', deliverytime, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updateDeliveryTime(deliverytime: DeliveryTimeModel) {
    
    return this.http
      .put(API_URL + '/DeliveryTime/UpdateDeliveryTime', deliverytime, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllDeliveryTimes(): Observable<DeliveryTimeModel[]> {
    return this.http.get(API_URL + '/DeliveryTime/ReadDeliveryTimes', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteDeliveryTime(deliverytime: DeliveryTimeModel) {
    
    return this.http
      .delete(API_URL + '/DeliveryTime/DeleteDeliveryTime', {
        headers: {},
        body: deliverytime,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
